
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/[articleId]",
      function () {
        return require("private-next-pages/article/[articleId]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/[articleId]"])
      });
    }
  